import Vue from 'vue';
import Router from 'vue-router';

import Index from '@/views/index.vue';
import About from '@/views/about/index.vue';
import Benefit from '@/views/benefit/index.vue';
import Profile from '@/views/profile/index.vue';
import Recruit from '@/views/recruit/index.vue';
import Vision from '@/views/vision/index.vue';
import Professionals from '@/views/professionals/index.vue';
import Voice01 from '@/views/professionals/voice/01/index.vue';
import Voice02 from '@/views/professionals/voice/02/index.vue';
import Voice03 from '@/views/professionals/voice/03/index.vue';
import Voice04 from '@/views/professionals/voice/04/index.vue';
import Voice05 from '@/views/professionals/voice/05/index.vue';
import Voice06 from '@/views/professionals/voice/06/index.vue';
import Voice07 from '@/views/professionals/voice/07/index.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      props: {
        title: 'ＪＲ九州ホテルズアンドリゾーツ 新卒・中途採用',
      },
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      props: {
        title: 'パーパス｜ＪＲ九州ホテルズアンドリゾーツ 新卒・中途採用',
      },
    },
    {
      path: '/professionals',
      name: 'professionals',
      component: Professionals,
      props: {
        title: 'PROFESSIONALS一覧｜ＪＲ九州ホテルズアンドリゾーツ 新卒・中途採用',
      },
    },
    {
      path: '/professionals/voice/01',
      name: 'professionals/voice/01',
      component: Voice01,
      props: {
        title: '竹村 亜由美｜ＪＲ九州ホテル ブラッサム福岡 支配人',
      },
    },
    {
      path: '/professionals/voice/02',
      name: 'professionals/voice/02',
      component: Voice02,
      props: {
        title: '野内 諒｜THE BLOSSOM HIBIYA 副支配人',
      },
    },
    {
      path: '/professionals/voice/03',
      name: 'professionals/voice/03',
      component: Voice03,
      props: {
        title: '呉 君｜THE BLOSSOM KYOTO マネージャー',
      },
    },
    {
      path: '/professionals/voice/04',
      name: 'professionals/voice/04',
      component: Voice04,
      props: {
        title: 'ポロスオ ユスティナ マウゴジャタ｜ＪＲ九州ホテルブラッサム新宿 マネージャー',
      },
    },
    {
      path: '/professionals/voice/05',
      name: 'professionals/voice/05',
      component: Voice05,
      props: {
        title: '本田 まい｜花べっぷ ホテルスタッフ',
      },
    },
    {
      path: '/professionals/voice/06',
      name: 'professionals/voice/06',
      component: Voice06,
      props: {
        title: '内田 塁｜本社 人事部マネージャー',
      },
    },
    {
      path: '/professionals/voice/07',
      name: 'professionals/voice/07',
      component: Voice07,
      props: {
        title: '村岡 史織｜ＪＲ九州ホテル鹿児島 ホテルスタッフ',
      },
    },
    {
      path: '/benefit',
      name: 'benefit',
      component: Benefit,
      props: {
        title: '福利厚生・育成制度｜ＪＲ九州ホテルズアンドリゾーツ 新卒・中途採用',
      },
    },
    {
      path: '/vision',
      name: 'vision',
      component: Vision,
      props: {
        title: '代表インタビュー｜ＪＲ九州ホテルズアンドリゾーツ 新卒・中途採用',
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      props: {
        title: '事業内容・会社概要・ホテル一覧｜ＪＲ九州ホテルズアンドリゾーツ 新卒・中途採用',
      },
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: Recruit,
      props: {
        title: '採用までの流れ・募集要項｜ＪＲ九州ホテルズアンドリゾーツ 新卒・中途採用',
      },
    },
    {
      path: '*',
      redirect: {
        name: 'index',
      },
    },
  ],
  scrollBehavior(to: any, from: any, savedPosition: any): Promise<any> {
    return new Promise((resolve: any, reject: any): any => {
      setTimeout((): void => {
        if (to.name === 'recruit' && to.hash) {
          resolve();
        } else {
          resolve({x: 0, y: 0});
        }
      }, 100);
    });
  },
});
